<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：商品管理-商品编辑-基础信息
    -->
  <div class="basic-setting-content pl16 pr16">
    <!--基本信息-->
    <div class="common-form">基本信息</div>
      <el-form-item label="奖品名称" :rules="[{ required: true, message: '请输入奖品名称' }]" prop="model.prize_name">
        <el-input v-model="form.model.prize_name" placeholder="请输入奖品名称"></el-input>

      </el-form-item>
      <el-form-item label="奖品图片" :rules="[{ required: true, message: '请上传商品图片' }]" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.image">
          <transition-group>
            <div class="item" v-for="item in form.model.image" :key="item.file_path">
              <img v-img-url="item.file_path" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(item)"><i class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>
     <!--商品图片组件-->
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
      <el-form-item label="奖品类型" :rules="[{ required: true, message: '请选择奖品类型' }]" prop="model.type">
        <el-radio-group v-model="form.model.type" >
          <el-radio :label="10">月抽奖</el-radio>
          <el-radio :label="20">复活奖</el-radio>
          <el-radio :label="30">豪华奖</el-radio>

        </el-radio-group>
      </el-form-item>



      <el-form-item label="奖品数量 " :rules="[{ required: true, message: '请输入奖品数量' }]" prop="model.prize_num">
        <el-input v-model="form.model.prize_num"  placeholder="请输入奖品数量" type="number"></el-input>

      </el-form-item>
      <el-form-item label="排序"><el-input type="number" v-model="form.model.sort" placeholder="请输入排序"></el-input></el-form-item>


      <el-form-item label="奖品状态" :rules="[{ required: true, message: '请选择奖品状态' }]" prop="model.is_status">
        <el-radio-group v-model="form.model.is_status" >
          <el-radio :label="10">启用</el-radio>
          <el-radio :label="20">禁用</el-radio>


        </el-radio-group>
      </el-form-item>


  </div>
</template>

<script>

import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      isProductUpload: false
    };
  },
  inject: ['form'],
  created() {

  },
  methods: {

    /*打开上传图片*/
    openProductUpload: function() {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.model.image.concat(e);
        this.$set(this.form.model, 'image', imgs);
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(e) {
      for (var i = 0; i < this.form.model.image.length; i++) {
        if (e.file_id == this.form.model.image[i].file_id) {
          this.form.model.image.splice(i, 1);
        }
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/lottery/prize/part/Basic.vue